"use strict";
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.substituteDeepPaths = exports.endsInArray = void 0;
const lodash = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const error_1 = require("../error");
const { cloneDeep } = lodash;
const endsInArray = (permission) => permission.slice(permission.length - 2) === '[]';
exports.endsInArray = endsInArray;
// note: this mutates target
const substitutePath = ({ key, proposed, target, }) => {
    // handle terminating array
    if ((0, exports.endsInArray)(key)) {
        const trimmedKey = key.slice(0, -2);
        // delete key if not defined in proposed
        if (!(trimmedKey in proposed) && trimmedKey in target) {
            delete target[trimmedKey];
            return;
        }
        const array = proposed[trimmedKey];
        (0, error_1.finleyAssert)(array === null || array === undefined || Array.isArray(array), `[key:${key}] specified a nil-ish array, but got ${typeof proposed}`);
        target[trimmedKey] = array;
        return;
    }
    // delete key if not defined in proposed
    // js allows delete target[key] even if key does not exist in target
    if (!(key in proposed)) {
        delete target[key];
        return;
    }
    // anything else should resolve to nil-ish primitive or an array
    const val = proposed[key];
    (0, error_1.finleyAssert)(finley_types_1.typeguards.isPrimitive(val) || Array.isArray(val), `[key:${key}] specified a nil-ish primitive, but got ${typeof val}`);
    target[key] = val;
};
// note: this mutates target
const substituteDeepPath = ({ path, proposed, target, }) => {
    // split path by "."
    const pathSplit = path.split('.');
    // remove root of path
    const root = pathSplit.shift();
    // should never occur
    (0, error_1.finleyAssert)(root !== undefined, `Path permission does not exist`);
    // terminating condition, part 1
    // we have hit a primitive or array to stub in
    if (pathSplit.length === 0) {
        substitutePath({ key: root, proposed, target });
        return;
    }
    // terminating condition part 2
    // we have hit a propertyWithTerminating.*
    // we just stub in the entire section, if defined.
    // if proposed is undefined, delete the key from the target
    if (pathSplit.length === 1 && pathSplit[0] === '*') {
        // delete key if not defined in proposed
        if (!(root in proposed) && root in target) {
            delete target[root];
            return;
        }
        target[root] = proposed[root];
        return;
    }
    // todo: handle array
    // this is complex, and likely problematic, as ordering in many array properties
    // is mutatable. there is no guarante current (target) vs proposed ordering is
    // still intact, and stubbing in individual properties when order is not guaranteed
    // is likely incorrect.
    if ((0, exports.endsInArray)(root)) {
        throw new error_1.FinleyError('Editing nested properties within an array is currently not supported.');
    }
    // no-op, proposed object terminated early
    // mutating this higher level section is not explicitly permissioned
    if (!(root in proposed) ||
        proposed[root] === undefined ||
        proposed[root] === null) {
        return;
    }
    (0, error_1.finleyAssert)(typeof proposed[root] === 'object' && !Array.isArray(proposed[root]), `proposed [key:${root}] must be of type object.`);
    // if root is not in target, but proposed has this defined
    // we need to init this new object in target.
    if (!(root in target)) {
        target[root] = {};
    }
    // handle situation where root is in target
    // but is null or undefined
    if (target[root] === null || target[root] === undefined) {
        target[root] = {};
    }
    // at this point target[root] must be an object
    (0, error_1.finleyAssert)(typeof target[root] === 'object' &&
        !Array.isArray(target[root]) &&
        target[root] !== null, `target [key:${root}] must be of type object.`);
    // we have a non-terminating wildcard
    // all keys in proposed are fair game to substitute
    if (pathSplit[0] === '*') {
        // throw away wildcard
        pathSplit.shift();
        Object.keys(proposed[root]).forEach((key) => {
            // recursively backtrack
            pathSplit.unshift(key);
            substituteDeepPath({
                path: pathSplit.join('.'),
                proposed: proposed[root],
                target: target[root],
            });
            pathSplit.shift();
        });
        return;
    }
    substituteDeepPath({
        path: pathSplit.join('.'),
        proposed: proposed[root],
        target: target[root],
    });
};
/**
 * Deeply substitutes values from proposed to current
 * based upon the paths provided.
 *
 * DOES NOT SUPPORT:
 * - substituting nested properties within an array
 */
const substituteDeepPaths = ({ proposed, current, paths, }) => {
    const target = cloneDeep(current);
    paths.forEach((path) => {
        substituteDeepPath({
            path,
            proposed,
            target,
        });
    });
    return target;
};
exports.substituteDeepPaths = substituteDeepPaths;
//# sourceMappingURL=jsonSubstitute.js.map